import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { TourReactStep } from 'webapp/models-custom/tour-react';
import TourReactBase from 'webapp/models-custom/tour-react';

export default class GenieSkillsTour extends TourReactBase {
	static keyForPersistantDone = UserSettingsKey.GENIE_SKILLS;

	get id(): string {
		return TourId.GENIE_SKILLS;
	}

	override get keyForPersistantDone(): string {
		return GenieSkillsTour.keyForPersistantDone;
	}

	get steps(): TourReactStep[] {
		return [{ id: 'skills', anchorId: 'skills', side: 'right', align: 'start' }];
	}
}
